import React from 'react';
import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from './AnnouncementBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { WhatsAppButton } from './WhatsAppButton';
import { CartDrawer } from '../cart/CartDrawer';
import { FloatingCart } from '../cart/FloatingCart';
export function SiteLayout() {
  return <div className="min-h-screen w-full bg-white" data-id="element-344" data-mp="3mxmyv65kwfyo">
      <ScrollToTop data-id="element-345" data-mp="3mw27fpek9d51" />
      <AnnouncementBar data-id="element-346" data-mp="3hzliiszjeuqw" />
      <Header data-id="element-347" data-mp="3i03f5qq43azc" />
      <main data-id="element-348" data-mp="3i0mt6wcn5f83">
        <Outlet data-id="element-349" data-mp="3i150co0uddus" />
      </main>
      <Footer data-id="element-350" data-mp="itvnp7aozo3" />
      <WhatsAppButton data-id="element-351" data-mp="ik8e9dmx6m3" />
      <FloatingCart data-id="element-352" data-mp="jvj6t5hzemp" />
      <CartDrawer data-id="element-353" data-mp="keq7etm0ily" />
    </div>;
}